<template>
    <div id="app">

        <div style="display: flex;flex-direction: row">
            <p>选择媒体：</p>
            <el-select v-model="curAdPlatId" placeholder="请选择">
                <el-option
                    v-for="item in selectPlatformList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                </el-option>
            </el-select>
        </div>


        <div style="display: flex;flex-direction: column">

            <h1>一、设置账号与广告组</h1>


            <h2>账号</h2>

            <div style="display: flex;flex-direction: row">

                <el-button>添加</el-button>

                <div style="display: flex;flex-direction: row;margin-left: 10px">

                    <p>title</p>

                    <el-button>delete</el-button>

                </div>

            </div>

            <h2>广告组规则配置</h2>


            <h1>二、设置广告计划</h1>

            <h2>计划基本信息</h2>

            <h2>定向包</h2>

            <h1>三、设置创意素材</h1>

            <h2>创意基本信息</h2>

            <h2>标题包</h2>
            <h2>创意素材</h2>
            <h2>监测链接</h2>


        </div>


    </div>
</template>

<script>

import Vue from 'vue';
import {
    Table,
    TableColumn,
    FormItem,
    Input,
    Button,
    Dialog,
    Loading,
    Form,
    MessageBox,
    Notification,
    Tabs,
    TabPane,
    Select,
    Option
} from 'element-ui';
import {ToolAdPlatMap} from '../../../../utils/map'
import AccountPage from './account';

Vue.use(Table)
Vue.use(TableColumn)
Vue.use(Input)
Vue.use(Button)
Vue.use(FormItem)
Vue.use(Form)
Vue.use(Dialog)
Vue.use(Tabs)
Vue.use(TabPane)
Vue.use(Select)
Vue.use(Option)
Vue.use(Loading)
Vue.prototype.$confirm = MessageBox.confirm
Vue.prototype.$notify = Notification

export default {
    components: {AccountPage},
    data() {
        return {
            curAdPlatId: '400',
            selectPlatformList: ToolAdPlatMap,
        }
    },
    created() {

    },
    methods: {
        startHacking() {
            console.log("button click");
        }
    }
}
</script>

<style>
#app {
    font-family: Helvetica, sans-serif;
    text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/pages/home/promotion/createBatch/index.vue